import MOTOR_FIELDS from '../../consts/motor';
import COMBO_FIELDS from '../../consts/combo-fields';

/**
 * Types
 */

export const CombosTypes = {
    SET_COMBO: 'combos/SET_COMBO',
    SET_COMISSAO: 'combos/SET_COMISSAO',
    SET_LISTA_COMBOS: 'combos/SET_LISTA_COMBOS',
    CALCULAR_COTACAO: 'combos/CALCULAR_COTACAO',
    CALCULAR_COTACAO_SUCCESS: 'combos/CALCULAR_COTACAO_SUCCESS',
    CALCULAR_COTACAO_FAILURE: 'combos/CALCULAR_COTACAO_FAILURE',
    SALVAR_COTACAO_RESET: 'combos/SALVAR_COTACAO_RESET',
    SALVAR_COTACAO: 'combos/SALVAR_COTACAO',
    SALVAR_COTACAO_SUCCESS: 'combos/SALVAR_COTACAO_SUCCESS',
    SALVAR_COTACAO_FAILURE: 'combos/SALVAR_COTACAO_FAILURE',
    RESET: 'combos/RESET'
};

/**
 * Reducer
 */

let INITIAL_STATE = {
    comissaoSelecionada: null
};

export function combosReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CombosTypes.RESET: {
            return {
                ...INITIAL_STATE
            };
        }
        case CombosTypes.SET_COMBO: {
            return {
                ...state,
                [COMBO_FIELDS.SELECIONADO.THIS]: action.payload.combo
            };
        }
        case CombosTypes.SET_COMISSAO: {
            return {
                ...state,
                comissaoSelecionada: action.payload.comissao
            };
        }
        case CombosTypes.CALCULAR_COTACAO: {
            return {
                ...state,
                loadingCalculo: true,
                msgErroCalculo: null,
                calculoSuccess: false
            };
        }
        case CombosTypes.CALCULAR_COTACAO_SUCCESS: {
            return {
                ...state,
                [MOTOR_FIELDS.RESULTADO_CALCULO]: action.payload[MOTOR_FIELDS.RESULTADO_CALCULO],
                loadingCalculo: false,
                msgErroCalculo: null,
                calculoSuccess: true
            };
        }
        case CombosTypes.CALCULAR_COTACAO_FAILURE: {
            return {
                ...state,
                loadingCalculo: false,
                msgErroCalculo: action.payload.msgErro,
                calculoSuccess: false
            };
        }
        case CombosTypes.SALVAR_COTACAO_RESET: {
            return {
                ...state,
                saveCotacaoSucess: false,
                loadingSaveCotacao: false,
                msgErroSaveCotacao: null
            };
        }
        case CombosTypes.SALVAR_COTACAO: {
            return {
                ...state,
                saveCotacaoSucess: false,
                loadingSaveCotacao: true,
                msgErroSaveCotacao: null
            };
        }
        case CombosTypes.SALVAR_COTACAO_SUCCESS: {
            return {
                ...state,
                saveCotacaoSuccess: true,
                loadingSaveCotacao: false,
                msgErroSaveCotacao: null
            };
        }
        case CombosTypes.SALVAR_COTACAO_FAILURE: {
            return {
                ...state,
                saveCotacaoSucess: false,
                loadingSaveCotacao: false,
                msgErroSaveCotacao: action.payload.msgErro
            };
        }
        case CombosTypes.SET_LISTA_COMBOS: {
            return {
                ...state,
                listaCombos: action.payload.listaCombos
            };
        }
        default:
            return state;
    }
}

/**
 * Actions
 */
export const Creators = {
    setCombo: (combo) => ({
        type: CombosTypes.SET_COMBO,
        payload: { combo }
    }),

    setComissao: (comissao) => ({
        type: CombosTypes.SET_COMISSAO,
        payload: { comissao }
    }),

    calcularCotacao: (dadosCotacao, comissao, comLog, todosCombos) => ({
        type: CombosTypes.CALCULAR_COTACAO,
        payload: { dadosCotacao, comissao, comLog, todosCombos }
    }),

    calcularCotacaoSuccess: (resultadoCalculo) => ({
        type: CombosTypes.CALCULAR_COTACAO_SUCCESS,
        payload: { resultadoCalculo }
    }),

    calcularCotacaoFailure: (msgErro) => ({
        type: CombosTypes.CALCULAR_COTACAO_FAILURE,
        payload: { msgErro }
    }),

    salvarCotacaoReset: () => ({
        type: CombosTypes.SALVAR_COTACAO_RESET
    }),

    salvarCotacao: (codigoCotacao, idCombo, parcelaEmGarantia, parcelaEmNaoGarantia) => ({
        type: CombosTypes.SALVAR_COTACAO,
        payload: { codigoCotacao, idCombo, parcelaEmGarantia, parcelaEmNaoGarantia }
    }),

    salvarCotacaoSuccess: () => ({
        type: CombosTypes.SALVAR_COTACAO_SUCCESS
    }),

    salvarCotacaoFailure: (msgErro) => ({
        type: CombosTypes.SALVAR_COTACAO_FAILURE,
        payload: { msgErro }
    }),

    setListaCombos: (listaCombos) => ({ type: CombosTypes.SET_LISTA_COMBOS, payload: { listaCombos } }),
    reset: () => ({
        type: CombosTypes.RESET
    })
};
